import React, { useState, useRef } from 'react';

import cx from 'classnames';

import datePickerStyles from 'components/Pages/Admin/Itinerary/Details/shared/DatePickerButton/index.module.css';
import Popover from 'components/shared/Popover';
import i18n from 'i18n';
import { getTranslationDateFormat } from 'utils/i18n/date';

import { FlightsDatePicker } from '../../shared';
import s from './index.module.css';

export function DatePickerButton(props) {
  const { onChange, item, isReadonly, itemIndex, dateFormat } = props;
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const buttonContainerRef = useRef();
  const isNoData = !item?.departureTime;
  const isDetailsEmpty = !item?.type;
  const dateValueFormat = item?.departureTime
    ? i18n.strftime(new Date(item.departureTime), getTranslationDateFormat(dateFormat))
    : '';

  // const handleOpenPopup = () => setIsPopupOpen(true);
  const handleClosePopup = () => setIsPopupOpen(false);
  const handleChange = (enteredValue) => {
    handleClosePopup();
    onChange({ itemIndex, newData: { departureTime: enteredValue } });
  };

  const handleClick = () => {
    if (isReadonly || !isDetailsEmpty) return;
    return setIsPopupOpen(true);
  };

  return (
    <div
      ref={buttonContainerRef}
      className={cx(
        datePickerStyles.datePickerButtonContainer,
        s.wrapper,
        isNoData && datePickerStyles.datePickerButtonContainerNoData,
        'custom-flights-datepicker-wrapper',
      )}
    >
      <button className={cx(datePickerStyles.datePickerButton, 'custom-flights-datepicker-btn')} onClick={handleClick}>
        {isNoData ? `Mar 20, ${new Date().getFullYear()}` : dateValueFormat}
      </button>

      {isPopupOpen && (
        <Popover
          mountEl={buttonContainerRef.current}
          anchorEl={buttonContainerRef.current}
          onClose={handleClosePopup}
          style={{ top: '40px', left: '30px', zIndex: '99999' }}
        >
          <div className={datePickerStyles.popupContainer}>
            <FlightsDatePicker onChange={handleChange} value={item?.departureTime} />
          </div>
        </Popover>
      )}
    </div>
  );
}
